import React, { useState, useContext } from 'react';
import { Card, Container, Table, Row, Col, Image, Button, Alert } from 'react-bootstrap';
import CompetitorsTableBody from './CompetitorsTableBody';
import PropTypes from 'prop-types';
import { joinCompetition, fetchCompetition } from '../../services/CompetitionService';
import { CompetitionContext } from '../../contexts/CompetitionContext';
import './CompetitionOverview.css'; // Import the CSS file

const CompetitionOverview = ({ competitors, lowestCompetitor, currentPeriod, onUsernameClick, isUserJoined, competitionId, setIsUserJoined, setCompetition }) => {
    const { competition } = useContext(CompetitionContext);
    const [alert, setAlert] = useState({ show: false, variant: '', message: '' });
    const [showAlert, setShowAlert] = useState(false);
    const startDate = new Date(currentPeriod.startDate).toDateString();
    const endDate = new Date(currentPeriod.endDate).toDateString();
    const validPointTarget = competition?.pointTarget !== undefined ? parseFloat(competition.pointTarget) : 0;

    console.log('pointTarget:', competition?.pointTarget); // Debugging line

    const handleJoinClick = async () => {
        try {
            await joinCompetition(competitionId);
            setIsUserJoined(true);
            setAlert({ show: true, variant: 'success', message: 'Successfully joined the competition!' });
            setShowAlert(true);
            const updatedCompetition = await fetchCompetition();
            setCompetition(updatedCompetition);
        } catch (error) {
            setAlert({ show: true, variant: 'danger', message: 'Failed to join the competition: ' + error.message });
            setShowAlert(true);
        }
    };

    const topCompetitor = competitors.length > 0 ? competitors[0] : null;

    return (
        <Container className="mt-3">
            {alert.show && showAlert && (
                <Alert variant={alert.variant} onClose={() => setShowAlert(false)} dismissible>
                    {alert.message}
                </Alert>
            )}
            <Row>
                <Col md={12}>
                    <Card className="mb-3 h-100">
                        <Card.Header as="h5">
                            Competition Details
                            {!isUserJoined && (
                                <Button variant="primary" style={{ float: 'right' }} onClick={handleJoinClick}>Join Competition</Button>
                            )}
                        </Card.Header>
                        <Card.Body>
                            <Card.Text>Current Period: {startDate} - {endDate}</Card.Text>
                            <Card.Text>🍰 Cake Threshold 🍰 for Current Period: {validPointTarget.toFixed(2)}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md={6}>
                    <Card className="mb-3 h-100">
                        <Card.Header as="h5">Current Minister</Card.Header>
                        <Card.Body>
                            {topCompetitor ? (
                                <>
                                    <Card.Title>{`${topCompetitor.firstName} 🥇`}</Card.Title>
                                    <Image src={topCompetitor.profilePicture} roundedCircle style={{ width: 80, height: 80, marginRight: 10 }} alt={topCompetitor.firstName} />
                                    <Card.Text>Points Current Period: {topCompetitor.totalPoints.toFixed(2)}</Card.Text>
                                </>
                            ) : (
                                <Card.Text>No competitors</Card.Text>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="mb-3 h-100">
                        <Card.Header as="h5">Current Cake Giver</Card.Header>
                        <Card.Body>
                            {lowestCompetitor ? (
                                <>
                                    <Card.Title>{`${lowestCompetitor.firstName} 🍰`}</Card.Title>
                                    <Image src={lowestCompetitor.profilePicture} roundedCircle style={{ width: 80, height: 80, marginRight: 10 }} alt={lowestCompetitor.firstName} />
                                    <Card.Text>Points Current Period: {lowestCompetitor.totalPoints.toFixed(2)}</Card.Text>
                                </>
                            ) : (
                                <Card.Text>No competitors</Card.Text>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md={12}>
                    <Card>
                        <Table className="mt-3" striped hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '30%' }}>Name</th>
                                    <th style={{ width: '20%' }}>Total Points</th>
                                    <th style={{ width: '20%' }}>Number of Activities</th>
                                    <th style={{ width: '15%' }}>Cake Progress</th>
                                </tr>
                            </thead>
                            <CompetitorsTableBody
                                competitors={competitors}
                                lowestCompetitor={lowestCompetitor}
                                pointTarget={validPointTarget}
                                onUsernameClick={onUsernameClick}
                            />
                        </Table>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

CompetitionOverview.propTypes = {
    competitors: PropTypes.arrayOf(PropTypes.shape({
        username: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        totalPoints: PropTypes.number.isRequired,
        meetsCriteria: PropTypes.bool.isRequired,
        progress: PropTypes.number.isRequired,
    })).isRequired,
    lowestCompetitor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired,
    }),
    currentPeriod: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
    }).isRequired,
    onUsernameClick: PropTypes.func.isRequired,
    isUserJoined: PropTypes.bool.isRequired,
    competitionId: PropTypes.string.isRequired,
    setIsUserJoined: PropTypes.func.isRequired,
    setCompetition: PropTypes.func.isRequired,
};

export default CompetitionOverview;
